 
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, inject } from '@angular/core';
import { AuthGuard } from './guards/auth.guard';
import { CmsGuard } from './guards/cms.guard';
import { NoAuthGuard } from './guards/no-auth.guard';

export function throwIfAlreadyLoaded(parentModule: any, moduleName: string): void {
  if (parentModule) {
    throw new Error(`${moduleName} has already been loaded. Import ${moduleName} modules in the AppModule only.`);
  }
}

@NgModule({
  declarations: [],
  imports: [],
  providers: [AuthGuard, NoAuthGuard, CmsGuard, provideHttpClient(withInterceptorsFromDi())],
})
export class CoreModule {
  constructor() {
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true });

    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
